import React, { Component } from 'react'
import { withFirebase } from '../Fb'
import { Row, Col, Button, CardBody } from 'reactstrap'
import {
  Tabs,
  Tab,
  Typography,
  CircularProgress,
  TextField,
  Card,
  Dialog,
  Paper,
  Alert,
} from '@mui/material'
import MessageEditor from '../Editor/MessageEditor'
import MessageListTemplates from '../Lists/MessageListTemplates'
import moment from 'moment-timezone'
import 'moment/locale/fi' // without this line it didn't work
moment.locale('fi') // use Finnish locale globally

const STATUS_TRANSLATIONS = {
  draft: 'Luonnos',
  scheduled: 'Ajoitettu',
  sent: 'Lähetetty',
}

const COST_PER_THOUSAND_MESSAGES = 1.0 // in euros

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <React.Fragment>{children}</React.Fragment>}
    </div>
  )
}

const STATS_CARDS = [
  { title: 'Lähetetyt', field: 'sent', icon: 'paper-plane' },
  { title: 'Toimitetut', field: 'delivered', icon: 'check' },
  { title: 'Näytöt', field: 'viewed', icon: 'eye' },
  { title: 'Klikkaukset', field: 'uniqueClicks', icon: 'mouse-pointer' },
  { title: 'Klikkaajat', field: 'clickers', icon: 'mouse-pointer' },
  { title: 'Avaukset', field: 'uniqueViews', icon: 'eye' },
  { title: 'SoftPalautuneet', field: 'softBounces', icon: 'redo' },
  { title: 'HardPalautuneet', field: 'hardBounces', icon: 'redo' },
  {
    title: 'Valitukset',
    field: 'complaints',
    icon: 'exclamation-triangle',
  },
  { title: 'Peruutukset', field: 'unsubscriptions', icon: 'times' },
]

class MessageListMessageStats extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      stats: null,
    }
  }

  componentDidMount() {
    this.setState({ loading: true })
    if (this.props.messageId) {
      this.props.firebase
        .getMessageListMessageStats(this.props.messageId, this.props.campaignId)
        .then((data) => {
          let stats = data.campaignStats || {}
          // check stats object for missing fields and set them to 0
          STATS_CARDS.forEach((card) => {
            if (!stats.hasOwnProperty(card.field)) {
              stats[card.field] = 0
            }
          })
          this.setState({ stats: stats, loading: false })
        })
        .catch((err) => {
          console.error('Error fetching message stats', err)
          this.setState({ loading: false })
        })
    }
  }

  render() {
    const { stats, loading } = this.state
    if (loading) {
      return <CircularProgress color='primary' />
    }
    if (!stats) {
      return <Typography>Ei tilastoja saatavilla.</Typography>
    }
    return (
      <div>
          <Typography variant='h5' gutterBottom>
            Viestin suorituskyky
          </Typography>
          <Paper elevation={3} style={{ padding: 10, width: '100%' }}>
          <Row className='mb-2 mt-4'>
            <Col>
              <Typography variant='body1' gutterBottom>
                Toimitettu
              </Typography>
              <Typography variant='h6' gutterBottom>
                {stats['delivered']}
              </Typography>
            </Col>
            <Col>
              <Typography variant='body1' gutterBottom>
                Avaukset 
              </Typography>
              <Typography variant='h6' gutterBottom>
                {stats['viewed']}
              </Typography>
            </Col>
            <Col>
              <Typography variant='body1' gutterBottom>
                Klikkaukset 
              </Typography>
              <Typography variant='h6' gutterBottom>
                {stats['clickers']}
              </Typography>
            </Col>
            <Col>
              <Typography variant='body1' gutterBottom>
                Tilauksen peruutukset 
              </Typography>
              <Typography variant='h6' gutterBottom>
                {stats['unsubscriptions']}
              </Typography>
              <Button size='sm' color='secondary' className='mt-2' onClick={() => {
                window.open('/admin/messaginglistsubscriptions?messageid=' + this.props.messageId, '_blank')
              }}> Katso peruutukset </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Typography variant='body1' gutterBottom>
                Toimitusaste
              </Typography>
              <Typography variant='h6' gutterBottom>
                {stats['sent'] > 0 ? ((stats['delivered'] / stats['sent']) * 100).toFixed(1) : 0} %
              </Typography>
            </Col>
            <Col>
              <Typography variant='body1' gutterBottom>
                Avausaste
              </Typography>
              <Typography variant='h6' gutterBottom>
                {stats['delived'] > 0 ? ((stats['viewed'] / stats['delivered']) * 100).toFixed(1) : 0} %
              </Typography>
            </Col>
            <Col>
              <Typography variant='body1' gutterBottom>
                Klikkausaste (CTR)
              </Typography>
              <Typography variant='h6' gutterBottom>
                {stats['delivered'] > 0 ? ((stats['clickers'] / stats['delivered']) * 100).toFixed(1) : 0} %
              </Typography>
            </Col>
            <Col>
              <Typography variant='body1' gutterBottom>
                Peruutusaste
              </Typography>
              <Typography variant='h6' gutterBottom>
                {stats['delivered'] > 0 ? ((stats['unsubscriptions'] / stats['delivered']) * 100).toFixed(1) : 0} %
              </Typography>
            </Col>
          </Row>
          <Row>
            <Col className='mt-5'>
              <Typography variant='caption' gutterBottom>
                Huom. Lähetettyjen viestien määrä voi poiketa listalla olevien henkilöiden määrästä, jos osa henkilöistä on aiemmin peruuttanut tilauksensa.
              </Typography>
            </Col>
          </Row>
        </Paper>
      </div>
    )
  }
}

class MessageListMessageDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      message: props.message || null,
      tabValue: 0,
      lists: null,
      loadingStats: true,
      listsSum: 0,
      testEmail: null,
      sendingTestEmail: false,
      sendingConfirmationOpen: false,
      deleteConfirmationOpen: false,
      sending: false,
      unsavedChanges: false,
      templateDialogOpen: false,
      templateDraft: null, // snapshot taken when the button is clicked
      templateName: '',
      savingTemplate: false,
      templateError: null,
      templateSavedName: null,
      templateApplyCount: 0,
    }
  }

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue })
  }

  updateData() {
    console.log('Update data for message details')
    this.setState({ loading: true, tabValue: 0 })
    // Fetch any additional data here and update state
    const { message } = this.state
    if (message && message.listids && message.listids.length > 0) {
      if (message.listids.length > 1) {
        this.props.firebase
          .getMessagingLists()
          .then((lists) => {
            const filtered = lists.filter((l) => message.listids.includes(l.id))
            const recipientCount = filtered.reduce((acc, l) => {
              if (l.result && l.result.count) {
                return acc + l.result.count
              }
              return acc
            }, 0)
            this.setState({
              lists: filtered,
              loading: false,
              listsSum: recipientCount,
            })
          })
          .catch((err) => {
            console.log('Error fetching lists', err)
          })
      } else {
        this.props.firebase
          .getMessagingList(message.listids[0])
          .then((list) => {
            console.log('Fetched list', list)
            this.setState({
              lists: [list],
              loading: false,
              listsSum: list.result ? list.result.count : 0,
            })
          })
          .catch((err) => {
            console.log('Error fetching list', err)
          })
      }
    } else {
      this.setState({ lists: [], loading: false })
    }
  }

  componentDidMount() {
    if (this.state.message) {
      console.log('Component did mount, updating data')
      this.updateData()
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.message && prevProps.message) {
      if (prevProps.message.id !== this.props.message.id) {
        this.setState({ message: this.props.message }, () => {
          console.log('Message changed, updating data')
          this.updateData()
        })
      }
    }
  }

  handleSaveMessage = (subject, html, text, replytoEmail, fromName) => {
    const { message } = this.state
    if (message && message.id) {
      const updated = { ...message }
      if (!updated.message) updated.message = {}
      updated.message.subject = subject
      updated.message.html = html
      updated.message.text = text
      if (replytoEmail) updated.replytoemail = replytoEmail
      if (fromName) updated.fromname = fromName
      this.setState({ loading: true })
      this.props.firebase
        .updateMessageListMessage(updated)
        .then(() => {
          this.setState({ message: updated, loading: false, unsavedChanges: false })
          if (this.props.onMessageUpdated) this.props.onMessageUpdated(updated)
        })
        .catch((err) => {
          console.error('Error updating message', err)
          this.setState({ loading: false })
        })
    }
  }

  sendMessage = () => {
    const { message } = this.state
    if (message && message.id) {
      this.setState({ sending: true })
      this.props.firebase
        .sendMessageListMessage(message.id)
        .then(() => {
          if (this.props.onMessageSent) this.props.onMessageSent(message.id)
          this.setState({ sending: false })
        })
        .catch((err) => {
          console.error('Error sending message', err)
          this.setState({ sending: false })
        })
    }
  }

  handleSelectTemplate = (template) => {
    const { message } = this.state
    if (message && message.id) {
      const updated = { ...message }
      // Clone the nested object too: it is the same reference the parent container holds
      // in its messages array, so assigning into it edited the parent's data in place.
      updated.message = { ...(updated.message || {}) }
      updated.message.html = template.html || ''
      // Only templates saved from a message carry a subject; system ones have none and
      // must leave the message subject alone.
      if (template.subject) updated.message.subject = template.subject
      this.setState({
        message: updated,
        tabValue: 1,
        templateSavedName: null,
        templateApplyCount: this.state.templateApplyCount + 1,
      })
    }
  }

  handleSaveAsTemplate = ({ subject, html }) => {
    const { message } = this.state
    const defaultName = (message && message.title) || subject || 'Mallipohja'
    this.setState({
      templateDialogOpen: true,
      templateDraft: { subject: subject || '', html: html || '' },
      templateName: defaultName,
      templateError: null,
      templateSavedName: null,
    })
  }

  closeTemplateDialog = () => {
    this.setState({ templateDialogOpen: false, templateDraft: null, templateError: null })
  }

  handleConfirmSaveTemplate = () => {
    const { templateDraft, templateName } = this.state
    const name = (templateName || '').trim()
    if (!templateDraft || !name) return
    // The editor inlines pasted/uploaded images as base64 data URIs and a Firestore
    // document tops out at 1 MB, so say so instead of failing with INVALID_ARGUMENT.
    if ((templateDraft.html || '').length > 900000) {
      this.setState({
        templateError:
          'Viesti on liian suuri mallipohjaksi, todennäköisesti suurten kuvien takia. Käytä kuvalinkkejä upotettujen kuvien sijaan.',
      })
      return
    }
    this.setState({ savingTemplate: true, templateError: null })
    this.props.firebase
      .createMessageListMessageTemplate({
        name,
        subject: templateDraft.subject || '',
        html: templateDraft.html || '',
      })
      .then(() => {
        this.setState({
          savingTemplate: false,
          templateDialogOpen: false,
          templateDraft: null,
          templateName: '',
          templateSavedName: name,
        })
      })
      .catch((err) => {
        console.error('Error saving message template', err)
        this.setState({
          savingTemplate: false,
          templateError:
            err && err.code === 'permission-denied'
              ? 'Ei käyttöoikeutta mallipohjien tallentamiseen. Ota yhteyttä tukeen.'
              : 'Mallipohjan tallennus ei onnistunut. Yritä uudelleen.',
        })
      })
  }


  render() {
    const { id, title, created, status, message, campaignId } = this.props.message || {}
    return (
      <div style={{ padding: 20, backgroundColor: 'white' }}>
        <Row>
          <Col>
            <Typography variant='h4' gutterBottom>
              {title}
            </Typography>
          </Col>
          <Col className='text-right'>
            {status !== 'sent' && (
              <Button
                size={'sm'}
                onClick={() => this.setState({ deleteConfirmationOpen: true })}
                color='danger'
              >
                Poista viesti
              </Button>
            )}
          </Col>
        </Row>
        <Row className='mt-2 border-bottom mb-2'>
          <Col>
            <Tabs
              value={this.state.tabValue}
              indicatorColor='primary'
              // textColor="primary"
              onChange={this.handleTabChange}
              // aria-label="disabled tabs example"
              variant='scrollable'
            >
              <Tab label='Tiedot' />
              <Tab label='Viesti' />
              <Tab label='Tilastot' disabled={status !== 'sent'} />
              <Tab label='Mallipohjat' disabled={status === 'sent'} />
            </Tabs>

          </Col>
        </Row>
        <Row>
          <Col>
            <TabPanel value={this.state.tabValue} index={0}>
              <Row className='mb-2'>
                <Col xs={3} className='pt-1'>
                  <b>Tehty</b>
                </Col>
                <Col>
                  <Typography variant='subtitle2' gutterBottom>
                    {created ? moment.unix(created.seconds).format('LLL') : ''}
                  </Typography>
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col xs={3} className='pt-1'>
                  <b>Tila</b>
                </Col>
                <Col>
                  <Typography variant='subtitle2' gutterBottom>
                    {STATUS_TRANSLATIONS[status ? status : 'draft']}
                  </Typography>
                </Col>
              </Row>
              {status === 'scheduled' && this.props.message.scheduled ? (
                <Row className='mb-2'>
                  <Col xs={3} className='pt-1'>
                    <b>Ajoitettu</b>
                  </Col>
                  <Col>
                    <Typography variant='subtitle2' gutterBottom>
                      {moment
                        .unix(this.props.message.scheduled.seconds)
                        .format('LLL')}
                    </Typography>
                  </Col>
                </Row>
              ) : null}
              {status === 'sent' && this.props.message.senttimestamp ? (
                <Row className='mb-2'>
                  <Col xs={3} className='pt-1'>
                    <b>Lähetetty</b>
                  </Col>
                  <Col>
                    <Typography variant='subtitle2' gutterBottom>
                      {moment
                        .unix(this.props.message.senttimestamp.seconds)
                        .format('LLL')}
                    </Typography>
                  </Col>
                </Row>
              ) : null}
              <Row className='mb-2'>
                <Col xs={3} className='pt-1'>
                  <b>Listat</b>
                </Col>

                <Col>
                  <Typography variant='subtitle2' gutterBottom>
                    {this.state.loading && <CircularProgress size={14} />}
                    {!this.state.loading &&
                      this.state.lists &&
                      this.state.lists.length > 0 && (
                        <span>
                          {this.state.lists.map((l, i) => (
                            <span key={l.id}>
                              {l.name}
                              {i < this.state.lists.length - 1 && ', '}
                            </span>
                          ))}
                        </span>
                      )}
                    {!this.state.loading &&
                      (!this.state.lists || this.state.lists.length === 0) && (
                        <span>Ei listoja</span>
                      )}
                  </Typography>
                </Col>
              </Row>
              {status === 'sent' &&
              this.props.message.message.sent &&
              this.props.message.stats ? (
                <>
                  <Row className='mb-2'>
                    <Col xs={3} className='pt-1'>
                      <b>Vastaanottajia listoissa</b>
                    </Col>
                    <Col>{this.props.message.stats.sentcount}</Col>
                  </Row>
                  <Row className='mb-2'>
                    <Col xs={3} className='pt-1'></Col>
                    <Col>
                      <Typography variant='caption' gutterBottom>
                        Kustannus:{' '}
                        {(
                          (this.props.message.stats.sentcount / 1000) *
                          COST_PER_THOUSAND_MESSAGES
                        )
                          .toFixed(2)
                          .replace('.', ',')}{' '}
                        € (alv 0).
                      </Typography>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row>
                    <Col xs={3} className='pt-1'>
                      <b>Vastaanottajia listoissa</b>
                    </Col>
                    <Col>{this.state.listsSum} </Col>
                  </Row>
                  <Row className='mb-2'>
                    <Col xs={3} className='pt-1'></Col>
                    <Col>
                      <Typography variant='caption' gutterBottom>
                        Kustannus noin:{' '}
                        {(
                          (this.state.listsSum / 1000) *
                          COST_PER_THOUSAND_MESSAGES
                        )
                          .toFixed(2)
                          .replace('.', ',')}{' '}
                        € (alv 0). Jos lista on dynaaminen, niin hinta voi olla
                        eri kuin arvio.
                        <br />
                        (Laskutetaan viestien määrän mukaan, hinta per 1000
                        viestiä {COST_PER_THOUSAND_MESSAGES} € alv 0).
                      </Typography>
                    </Col>
                  </Row>
                </>
              )}
              <Row>
                {' '}
                <Col xs={3} className='pt-1'>
                  <b>Vastausosoite</b>
                </Col>
                <Col>
                  <TextField
                    id='replytoEmail'
                    label='Vastausosoite'
                    variant='outlined'
                    size='small'
                    style={{ marginRight: 10 }}
                    value={
                      this.state.message && this.state.message.replytoemail
                        ? this.state.message.replytoemail
                        : ''
                    }
                    onChange={(e) => {
                      const updated = { ...this.state.message }
                      updated.replytoemail = e.target.value
                      this.setState({ message: updated, unsavedChanges: true })
                    }}
                  />
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col xs={3} className='pt-1'></Col>
                <Col>
                  <Typography variant='caption' gutterBottom>
                    Asiakkaat näkevät tämän osoitteen vastatessaan viestiin.
                    Jätä tyhjäksi käyttääksesi oletusosoitetta johon ei voi
                    vastata.
                  </Typography>
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col xs={3} className='pt-1'>
                  <b>Lähettäjän nimi</b>
                </Col>
                <Col>
                  <TextField
                    id='fromName'
                    label='Lähettäjän nimi'
                    variant='outlined'
                    size='small'
                    style={{ marginRight: 10 }}
                    value={this.state.message && this.state.message.fromname ? this.state.message.fromname : ''}
                    onChange={(e) => {
                      const updated = { ...this.state.message }
                      updated.fromname = e.target.value
                      this.setState({ message: updated, unsavedChanges: true })
                    }}
                  />
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col xs={3} className='pt-1'></Col>
                <Col>
                  <Typography variant='caption' gutterBottom>
                    Asiakkaat näkevät tämän nimen viestin lähettäjänä. Jos jätät
                    tyhjäksi, käytetään oletusnimeä "Hallikirje".
                  </Typography>
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col>
                  <Button
                    disabled={!this.state.unsavedChanges}
                    color='primary'
                    onClick={() => {
                      this.handleSaveMessage(
                        this.state.message && this.state.message.message
                          ? this.state.message.message.subject
                          : '',
                        this.state.message && this.state.message.message ? this.state.message.message.html : '',
                        this.state.message && this.state.message.message ? this.state.message.message.text : '',
                        this.state.message && this.state.message.replytoemail ? this.state.message.replytoemail : '',
                        this.state.message && this.state.message.fromname ? this.state.message.fromname : ''
                      )
                    }}
                  >
                    Tallenna
                  </Button>
                  <Button
                    disabled={
                      status !== 'draft' || !(message && message.subject) || this.state.sending || this.state.unsavedChanges
                    }
                    color='primary'
                    onClick={() => {
                      this.setState({ sendingConfirmationOpen: true })
                    }}
                  >
                    Lähetä viesti
                  </Button>
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col>
                  <Typography variant='caption' gutterBottom>
                    ID: {id}
                  </Typography>
                </Col>
              </Row>
            </TabPanel>
            <TabPanel value={this.state.tabValue} index={1}>
              {this.state.loading && <CircularProgress color='primary' />}
              {!this.state.loading && this.state.message && (
                <div>
                  <Row className='p-3'>
                    <Col>
                      <Typography variant='body1' gutterBottom>
                        {this.state.message?.message?.subject ||
                          '(Ei otsikkoa)'}
                      </Typography>
                    </Col>
                    {/* <Col className='text-right'>
                      Dynaamiset kentät: {'{etunimi}'}, {'{sukunimi}'},{' '}
                      {'{kokonimi}'}
                    </Col> */}
                    {/* <Button color='primary' onClick={this.toggleEditor} disabled={this.state.sending || !this.props.message.listids || this.props.message.listids.length === 0}>
                          {this.state.sending ? 'Lähetys käynnissä...' : 'Lähetä viesti'}
                        </Button> */}
                  </Row>
                  {this.state.templateSavedName && (
                    <Row className='mb-2'>
                      <Col>
                        <Alert
                          severity='success'
                          onClose={() => this.setState({ templateSavedName: null })}
                        >
                          Mallipohja "{this.state.templateSavedName}" tallennettu. Löydät sen
                          Mallipohjat-välilehdeltä.
                        </Alert>
                      </Col>
                    </Row>
                  )}
                  <Row className='mt-2 mb-2'>
                    <Col>
                      {this.state.message &&
                      this.state.message.status === 'sent' ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: this.state.message.message
                              ? this.state.message.message.html
                              : '',
                          }}
                        ></div>
                      ) : (
                        <MessageEditor
                          // Remount when a template is applied: TinyMCE reads initialValue
                          // once, so a mounted editor would ignore the new body.
                          key={'msgeditor-' + this.state.templateApplyCount}
                          onSubmit={this.handleSaveMessage}
                          onSaveTemplate={this.handleSaveAsTemplate}
                          savingTemplate={this.state.savingTemplate}
                          submitText={'Tallenna'}
                          subject={
                            this.state.message.message
                              ? this.state.message.message.subject
                              : ''
                          }
                          body={
                            this.state.message.message
                              ? this.state.message.message.html
                              : ''
                          }
                          recipientids={null}
                          firebase={this.props.firebase}
                        />
                      )}
                    </Col>
                  </Row>
                {/* <Row className='mb-2'>
                <Col xs={3} className='pt-1'>
                  <b>Lähetä testiviesti</b>
                </Col>
                <Col>
                  <TextField
                    id='testEmail'
                    label='Sähköpostiosoite'
                    variant='outlined'
                    size='small'
                    style={{ marginRight: 10 }}
                    value={this.state.testEmail || ''}
                    onChange={(e) =>
                      this.setState({ testEmail: e.target.value })
                    }
                  />
                  <Button
                    size={'sm'}
                    color='primary'
                    onClick={() => {
                      this.setState({ sendingTestEmail: true })
                      this.props.firebase
                        .sendTestMessageListMessage(id, this.state.testEmail)
                        .then(() => {
                          this.setState({
                            sendingTestEmail: false,
                            testEmail: null,
                          })
                        })
                    }}
                    disabled={
                      !this.state.testEmail || this.state.sendingTestEmail
                    }
                  >
                    Lähetä testiviesti
                  </Button>
                </Col>
              </Row> */}
                </div>
              )}
            </TabPanel>
            <TabPanel value={this.state.tabValue} index={2}>
              <MessageListMessageStats messageId={id} campaignId={campaignId} {...this.props} />
            </TabPanel>
            <TabPanel value={this.state.tabValue} index={3}>
              {/* Additional tab if needed */}
              <MessageListTemplates onSelectTemplate={this.handleSelectTemplate} {...this.props} />
            </TabPanel>
          </Col>
        </Row>
        <Dialog
          open={this.state.sendingConfirmationOpen}
          aria-labelledby='sending-confirmation-title'
        >
          <div style={{ padding: 20, minWidth: 300 }}>
            <Typography
              variant='h6'
              id='sending-confirmation-title'
              gutterBottom
            >
              Lähetä viesti
            </Typography>
            <Typography variant='body1' gutterBottom>
              Oletko varma, että haluat lähettää tämän viestin?
            </Typography>
            <div className='text-right mt-4'>
              <Button
                onClick={() =>
                  this.setState({ sendingConfirmationOpen: false })
                }
                color='secondary'
                style={{ marginRight: 10 }}
              >
                Peruuta
              </Button>
              <Button
                onClick={() => {
                  this.setState({ sendingConfirmationOpen: false })
                  this.sendMessage()
                }}
                color='primary'
              >
                Lähetä viesti
              </Button>
            </div>
          </div>
        </Dialog>
        <Dialog
          open={this.state.deleteConfirmationOpen}
          aria-labelledby='delete-confirmation-title'
        >
          <div style={{ padding: 20, minWidth: 300 }}>
            <Typography
              variant='h6'
              id='delete-confirmation-title'
              gutterBottom
            >
              Poista viesti
            </Typography>
            <Typography variant='body1' gutterBottom>
              Oletko varma, että haluat poistaa tämän viestin? Toimintoa ei voi
              peruuttaa.
            </Typography>
            <div className='text-right mt-4'>
              <Button
                onClick={() => this.setState({ deleteConfirmationOpen: false })}
                color='secondary'
                style={{ marginRight: 10 }}
              >
                Peruuta
              </Button>
              <Button
                onClick={() => {
                  this.setState({ deleteConfirmationOpen: false })
                  if (this.props.onMessageDeleted)
                    this.props.onMessageDeleted(id)
                }}
                color='danger'
              >
                Poista viesti
              </Button>
            </div>
          </div>
        </Dialog>
        <Dialog
          open={this.state.templateDialogOpen}
          aria-labelledby='save-template-title'
        >
          <div style={{ padding: 20, minWidth: 380 }}>
            <Typography variant='h6' id='save-template-title' gutterBottom>
              Tallenna mallipohjaksi
            </Typography>
            <Typography variant='body2' gutterBottom>
              Anna mallipohjalle nimi. Mallipohjaan tallennetaan viestin otsikko ja sisältö
              sellaisena kuin ne ovat nyt editorissa. Viestiä itseään ei tallenneta.
            </Typography>
            <TextField
              autoFocus
              fullWidth
              size='small'
              variant='outlined'
              label='Mallipohjan nimi'
              value={this.state.templateName}
              onChange={(e) => this.setState({ templateName: e.target.value })}
              style={{ marginTop: 10 }}
            />
            {this.state.templateError && (
              <Typography variant='body2' color='error' style={{ marginTop: 10 }}>
                {this.state.templateError}
              </Typography>
            )}
            <div className='text-right mt-4'>
              <Button
                onClick={this.closeTemplateDialog}
                color='secondary'
                style={{ marginRight: 10 }}
                disabled={this.state.savingTemplate}
              >
                Peruuta
              </Button>
              <Button
                onClick={this.handleConfirmSaveTemplate}
                color='primary'
                disabled={this.state.savingTemplate || !(this.state.templateName || '').trim()}
              >
                {this.state.savingTemplate ? 'Tallennetaan...' : 'Tallenna'}
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
    )
  }
}

export default withFirebase(MessageListMessageDetails)
